// SALESdb
import infoPages from './info-pages';
// New section
// import dataPages from './data-pages';

// LABdb inital sales
// import labDbDataPages from './labdb-datas-pages';

// Dashboards
import adminDashboardPages from './admin-dashboard-pages';
import adminPages from './admin-pages';
// import CypherClass from '../config/Cypher';

// const Cypher = new CypherClass();

// ==============================|| MENU ITEMS ||============================== //
// const user = Cypher.getUser('resolveTK')
// console.log("main menu user", user)

const menuItems = {
    items: 
    // user && user?.id === 8491 
    // // 8603 
    // ? [infoPages, dataPages] : 
    [adminDashboardPages, infoPages, adminPages
        // , dataPages
        ]
};

export default menuItems;
